import React from 'react'
import "./VideoCard.css"

import train8 from "../../assests/video/train8.mp4";
import yoga from "../../assests/video/yoga.mp4";
import phone from "../../assests/video/phone.mp4";
const VideoCard = () => {
  return (
    <>
    <div className='v-card'>
        <div className='v-card-left'>
            <div className='v-box'>
                <video src={train8} autoPlay loop muted/>
                <div className='text'>
                    <div className='top'>
                       trend
                    </div>
                    <div className='btm'>
                       brand
                    </div>
                </div>
               
                {/* <div className='button2'>
                <button>read more <i class="fa-solid fa-chevron-right"></i> </button>
                </div> */}
                
              
            </div>
        </div>
        <div className='v-card-right'>
            <h1>GIRL DOING YOGA ON THE SHORE OF THE OCEAN ON THE BEACH</h1>
            <p>There are many variations of passages of have suffered
             alteration in some, by injected humour, or randomised .</p>
        </div>
    </div>
    
    </>
  )
}

export default VideoCard